import {
  _primaryControls,
  _increment,
  code,
  name,
  amount,
  type,
  customer_id,
  status,
  targetDateWarning,
  target_date,
} from './base';

export default {
  types: {
    _primaryControls,
    _increment,
    code,
    name,
    amount,
    type,
    customer_id,
    customer_po: {
      name: 'Customer PO',
      width: '8rem',
    },
    status,
    targetDateWarning,
    target_date,
  },

  sortable: [
    'code',
    'name',
    'status',
    'target_date',
  ],
};
